import { datadogRum } from '@datadog/browser-rum';
import { Archive } from '@mui/icons-material';
import { ActionMenu, toast } from '@side/pantry';
import { coreApi } from '$api-clients';
import { useCoreMutate } from '$api-clients/hooks';

type Props = {
  referralId: string;
  isArchived?: boolean;
};

export function ReferralTableActionsMenu({ referralId, isArchived }: Props) {
  const mutate = useCoreMutate();

  const handleToggleArchive = async () => {
    try {
      const { error } = await coreApi.PATCH('/referrals/{referralId}', {
        params: {
          path: {
            referralId,
          },
        },
        body: {
          isArchived: !isArchived,
        },
      });

      if (error) {
        const errorMessage = typeof error === 'string' ? error : error.message;
        throw new Error(errorMessage);
      }

      await mutate(['/referrals']);

      toast(
        'success',
        isArchived ? 'Referral unarchived' : 'Referral archived',
      );
    } catch (error) {
      const errorMessage = isArchived
        ? 'Failed to unarchive referral'
        : 'Failed to archive referral';
      datadogRum.addError(error, { message: errorMessage });
      toast('error', errorMessage);
    }
  };

  const menuOptions = [
    {
      label: isArchived
        ? 'Unarchive Client Referral'
        : 'Archive Client Referral',
      icon: <Archive fontSize="small" />,
      onClick: handleToggleArchive,
    },
  ];

  return (
    <ActionMenu
      title="Referral Actions"
      options={menuOptions}
      variant="borderless"
    />
  );
}
